export const mapEnumObjectKeys = (enumObject: any) => {
  return Object.keys(enumObject).filter((v) => isNaN(Number(v)))
}

export const mapEnumObjectValues = (enumObject: any): string[] => {
  return Object.values(enumObject)
}
